import { render, staticRenderFns } from "./SingleAddToBasket.vue?vue&type=template&id=f7560196"
import script from "./SingleAddToBasket.vue?vue&type=script&lang=js"
export * from "./SingleAddToBasket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports